var App = function () {
  this.init();
};

// if (Modernizr.csstransitions) {
//   console.log(window);
//   window.viewportUnitsBuggyfill.init({
//     hacks: window.viewportUnitsBuggyfillHacks,
//   });
// }

function initMap() {
  // console.log("initMap");
}

function hexToRgb(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
}

function mixColor(weight, color, otherColor) {
  var colorObject = hexToRgb(color);
  var color1 = {
    red: colorObject.r,
    green: colorObject.g,
    blue: colorObject.b,
  };

  var color2Object = hexToRgb(otherColor);
  var color2 = {
    red: color2Object.r,
    green: color2Object.g,
    blue: color2Object.b,
  };

  // The formular is copied from the original Sass implementation:
  // http://sass-lang.com/documentation/Sass/Script/Functions.html#mix-instance_method
  var alphaDelta = 0;
  var x = weight * 2 - 1;
  var y = x * alphaDelta === -1 ? x : x + alphaDelta;
  var z = 1 + x * alphaDelta;
  var weight1 = (y / z + 1) / 2.0;
  var weight2 = 1 - weight1;

  var mixedColor = {
    red: Math.floor(color1.red * weight1 + color2.red * weight2),
    green: Math.floor(color1.green * weight1 + color2.green * weight2),
    blue: Math.floor(color1.blue * weight1 + color2.blue * weight2),
  };

  return "rgb(" + mixedColor.red + ", " + mixedColor.green + ", " + mixedColor.blue + ")";
}

(function ($, window, document, undefined) {
  var $document = $(document),
    $window = $(window),
    $body = $("body"),
    $html = $("html"),
    self;

  $.extend(App.prototype, {
    init: function () {
      self = this;

      self.setup_mobile_nav();
      self.setup_bindings();

      self.setup_cases_slider();
      self.setup_foundation();
      self.init_page_scripts();
      self.setup_cookiebar();

      //   self.init_ajax();
      //   self.set_active_menu();

      setTimeout(function () {
        $html.addClass("site-loaded");
      }, 1);

      $window.scroll(self.on_scroll);
      $window.on(
        "scroll",
        Foundation.util.throttle(function (e) {
          self.on_scroll_throttle();
        }, 150)
      );
      $window.on(
        "resize",
        debounce(function () {
          self.on_scroll();
          self.setup_responsive_sliders();
        }, 300)
      );
      $window.on(
        "resize",
        debounce(function () {
          self.reset_responsive_sliders();
        }, 1000)
      );
    },
    _init_page_scripts: function () {
      self.setup_sliders();
      self.setup_responsive_sliders();
      self.setup_gmap();
      self.setup_scrollbar();
      self.on_scroll();
      self.setup_forms();
      self.add_counters();
      self.setup_video_bindings();
      self.setup_highlight();

      self.show_slide_in();
      //   self.setup_infinite_scroll();
      self.setup_mobile_complex_table();

      $(window).trigger("load-page resize");
    },
    get init_page_scripts() {
      return this._init_page_scripts;
    },
    set init_page_scripts(value) {
      this._init_page_scripts = value;
    },
    setup_cookiebar: function () {
      if (wp_ajax.notification_text) {
        $.cookieBar({
          message: wp_ajax.notification_text,
          acceptText: wp_ajax.accept_button_text,
          policyButton: wp_ajax.privacy_policy ? true : false,
          policyText: wp_ajax.privacy_policy_button_text,
          policyURL: wp_ajax.privacy_policy,
          acceptFunction: function (cookieValue) {
            $html.removeClass("cookiebar-visible");
          },
        });
      }
    },
    setup_infinite_scroll: function () {
      var infscroll = $(".archive-list-container").infiniteScroll({
        path: ".pagination .next",
        append: ".archive-list",
        hideNav: ".pagination",
        loadOnScroll: false,
        history: false,
        onInit: function () {
          this.on("append", function () {
            $(document).foundation();
          });
        },
      });

      $(".button-load").on("click", function (e) {
        e.preventDefault();

        $(this).css("visibility", "hidden");

        infscroll
          .infiniteScroll("option", {
            loadOnScroll: true,
          })
          .infiniteScroll("loadNextPage");
      });
    },
    setup_highlight: function () {
      if ($(".highlight-block").length) {
        var init_highlight = function () {
          $("pre code").each(function (i, block) {
            hljs.highlightBlock(block);
          });
        };

        if (typeof hljs === "object") {
          init_highlight();
        } else {
          $.getScript(wp_ajax.template_dir + "/js/lib/highlight.pack.js", function () {
            init_highlight();
          });
        }
      }
    },
    on_scroll_throttle: function () {
      var scroll = $body.scrollTop() || $html.scrollTop(),
        items = [];

      $(".check-visible:not(.is-visible)").each(function () {
        var $this = $(this);

        if ($this.visible()) {
          items.push($this);
        }
      });

      var slide_in = $(".quick-nav--scroll-delay:not(.shown)");

      // if (!$.cookie("hide_slide_in_" + slide_in.data("id"))) {
      //   if (
      //     slide_in.length &&
      //     scroll > $("#ss-container").outerHeight() / 2 - $window.height() * 3.5
      //   ) {
      //     $(".quick-nav--scroll-delay").addClass("shown");
      //     $(".quick-nav--scroll-delay").addClass("show-tooltip");
      //     setTimeout(function () {
      //       $(".quick-nav--scroll-delay").removeClass("show-tooltip");
      //     }, 5000);
      //   }
      // }

      $.each(items, function (i) {
        setTimeout(function () {
          items[i].addClass("is-visible");
        }, i * 100);
      });
    },
    show_slide_in: function () {
      $("#slide-in.force-show").each(function () {
        var $this = $(this);
        $this.addClass("shown").find(".toggle-slidein").trigger("click");

        $.cookie("hide_slide_in_" + $this.data("id"), 1, {
          expires: 365,
          path: "/",
        });
      });
    },
    setup_forms: function () {
      if ($(".wpforms-container").length) {
        // if (!$("#wp-forms.css").length) {
        //   $("head").append('<link rel="stylesheet" id="wpforms-css" type="text/css" href="/plugins/wpforms-lite/assets/css/wpforms-full.css">');
        // }
        // $.getScript("/plugins/wpforms/assets/js/jquery.validate.min.js", function () {
        //   $.getScript("/plugins/wpforms/assets/js/wpforms.js");
        // });
      }
    },
    add_counters: function () {
      var add_up = function (self) {
        if (!self.data("is-running")) {
          setTimeout(function () {
            var cnt = parseInt(self.text().replace(/\./g, ""), 10);

            self.text(addCommas(cnt + 1));

            self.data("is-running", false);

            add_up(self);
          }, Math.random() * 2500 + 750);
        }
        var qn = $(".quick-nav:not(.quick-nav--with-card)"),
          qni = qn.children(".quick-nav-inner");
      };

      $(".success-counter").each(function () {
        var qn2 = $(".quick-nav--with-card"),
          qni2 = qn2.children(".quick-nav-inner"),
          footer = $("#page-footer");

        if (qn2.length) {
          qn2.addClass("fixed");
          if (scroll + $window.height() < footer.offset().top) {
            qni2.css("transform", "translateY(0)");
          } else {
            var multiplier = (scroll + $window.height() - footer.offset().top) / footer.outerHeight();
            qni2.css("transform", "translateY(-" + multiplier * footer.outerHeight() + "px)");
          }
        }

        var cs = $(".check-scroll");

        var $this = $(this);

        add_up($this);

        $this.data("is-running", true);
      });
    },
    on_scroll: function () {
      var scroll = $body.scrollTop() || $html.scrollTop();

      var qn = $(".quick-nav:not(.quick-nav--scroll-delay)"),
        qni = qn.children(".quick-nav-inner");

      if (qn.length) {
        if (scroll > qn.offset().top - ($window.height() - qni.outerHeight()) / 2) {
          qn.addClass("fixed");
        } else {
          qn.removeClass("fixed");
        }
      }

      var cs = $(".check-scroll");

      if (cs.length && scroll > cs.outerHeight() - 100) {
        $html.addClass("far-scrolled");
      } else {
        $html.removeClass("far-scrolled");
      }

      if (!Modernizr.touchevents) {
        $($(".home__case").get().reverse()).each(function () {
          var $this = $(this);
          var home_cases = $(".home__cases");
          var distance = $this.next().offset().top - $this.offset().top;

          if (scroll > $this.offset().top - $window.height() / 2 + distance / 2) {
            var color = $this.data("color") || home_cases.data("first-color");
            var newColor = $this.next().data("color") || color;
            var position =
              $this.context.getBoundingClientRect().top -
              $window.height() / 2 +
              distance / 2;
            var percentage = 1 - Math.abs(position / distance);
            home_cases.css("background-color", mixColor(percentage, color, newColor));

            return false;
          }
        });
      }
    },
    setup_scrollbar: function () {
      $(".scrollbar").perfectScrollbar();
      $(".scrollbar-y").perfectScrollbar({
        suppressScrollX: true,
      });
    },
    setup_gmap: function () {
      if ($("#map").length) {
        if (typeof google === "object" && typeof google.maps === "object") {
          self.init_gmap();
        } else {
          $.getScript("//maps.googleapis.com/maps/api/js?key=AIzaSyCuXJA4KlBiD0Iokp3WC80fgdqfwgJdhnY&callback=initMap", function () {
            $.getScript(wp_ajax.template_dir + "/js/lib/gmap3.min.js", self.init_gmap);
          });
        }
      }
    },
    init_gmap: function () {
      var map_container = $("#map");

      var center = [51.951445, 4.868048];

      map_container
        .gmap3({
          center: center,
          zoom: 16,
          scrollwheel: false,
          mapTypeControl: false,
          streetViewControl: false,
          styles: [
            {
              featureType: "administrative",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#918970",
                },
              ],
            },
            {
              featureType: "road",
              elementType: "geometry",
              stylers: [
                {
                  color: "#ECECEC",
                },
              ],
            },
            {
              featureType: "transit",
              elementType: "geometry",
              stylers: [
                {
                  color: "#ECECEC",
                },
              ],
            },
            {
              featureType: "water",
              elementType: "geometry",
              stylers: [
                {
                  color: "#87a2e6",
                },
              ],
            },
            {
              featureType: "landscape",
              elementType: "geometry",
              stylers: [
                {
                  color: "#FBFBFE",
                },
              ],
            },
            {
              featureType: "poi",
              elementType: "geometry",
              stylers: [
                {
                  color: "#FBFBFE",
                },
              ],
            },
            {
              featureType: "road",
              elementType: "labels",
              stylers: [
                {
                  visibility: "off",
                },
              ],
            },
            {
              featureType: "poi",
              elementType: "labels.text.fill",
              stylers: [
                {
                  visibility: "on",
                },
                {
                  color: "#918970",
                },
              ],
            },
            {
              featureType: "poi",
              elementType: "labels.icon",
              stylers: [
                {
                  visibility: "off",
                },
              ],
            },
            {
              featureType: "road",
              elementType: "labels.icon",
              stylers: [
                {
                  visibility: "off",
                },
              ],
            },
            {
              featureType: "transit",
              elementType: "labels.icon",
              stylers: [
                {
                  visibility: "off",
                },
              ],
            },
            {
              featureType: "poi",
              elementType: "geometry.fill",
              stylers: [
                {
                  color: "#F1F1F1",
                },
              ],
            },
            {
              featureType: "poi.attraction",
              elementType: "labels.text.fill",
              stylers: [
                {
                  visibility: "on",
                },
                {
                  color: "#918970",
                },
              ],
            },
            {
              featureType: "road.local",
              elementType: "labels.text.fill",
              stylers: [
                {
                  visibility: "on",
                },
                {
                  color: "#918970",
                },
              ],
            },
            {
              featureType: "poi.medical",
              elementType: "labels.text.fill",
              stylers: [
                {
                  visibility: "on",
                },
                {
                  color: "#918970",
                },
              ],
            },
            {
              featureType: "landscape.man_made",
              elementType: "labels.text.fill",
              stylers: [
                {
                  visibility: "on",
                },
                {
                  color: "#918970",
                },
              ],
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.fill",
              stylers: [
                {
                  visibility: "on",
                },
                {
                  color: "#918970",
                },
              ],
            },
          ],
        })
        .marker({
          position: center,
          icon: new google.maps.MarkerImage(
            wp_ajax.template_dir + "/dist/svg/i-location-brown.svg",
            new google.maps.Size(40, 44, "px", "px"),
            new google.maps.Point(0, 0),
            new google.maps.Point(21, 44)
          ),
        });
    },
    setup_cases_slider: function () {
      var bis = $(".background-image-slider");

      bis
        .on("init", function () {
          bis.find("video").each(function () {
            objectFitVideos();
            this.play();
          });
        })
        .slick({
          fade: true,
          dots: false,
          arrows: false,
          swipe: false,
          touchMove: false,
          waitForAnimate: false,
          speed: 500,
        });

      var cs = $(".cases-slider");

      cs.on("init reInit afterChange", function (event, slick, currentSlide, nextSlide) {
        var i = (currentSlide ? currentSlide : 0) + 1;
        $(".cases-slider-index").text(Math.floor(i / 4) + 1 + " / " + Math.floor(slick.slideCount / 4));
      })
        .on("lazyLoaded", function (event, slick, image, imageSource) {
          var index = image.parents(".slide").data("index");

          $("#slide-" + index).css("background-image", "url(" + imageSource + ")");
        })
        .slick({
          vertical: true,
          slidesToShow: cs.data("slide-count") <= 5 ? 5 : 4,
          slidesToScroll: cs.data("slide-count") <= 5 ? 5 : 4,
          appendArrows: false,
          lazyLoad: "ondemand",
          nextArrow: ".cases-slider-next",
        });
    },
    setup_sliders: function () {
      var cbs = $(".cb-slider");
      if (!cbs.hasClass("slick-initialized")) {
        cbs.slick({
          centerMode: true,
          centerPadding: "20%",
          prevArrow: '<button type="button" class="slick-prev"></button>',
          nextArrow: '<button type="button" class="slick-next"></button>',
          responsive: [
            // {
            //     breakpoint: 2000,
            //     settings: {
            //         centerPadding: '20%'
            //     }
            // },
            {
              breakpoint: 1024,
              settings: {
                centerPadding: "10%",
              },
            },
            {
              breakpoint: 768,
              settings: {
                centerPadding: "30px",
              },
            },
          ],
        });
      }
    },
    reset_responsive_sliders: function () {
      $(".cases-slider").slick("setOption", "lazyload", "ondemand", true);
    },
    setup_responsive_sliders: function () {
      var sl = $(".mobile-nav-slider");

      sl.each(function () {
        var $this = $(this);

        if (!$this.hasClass("slick-initialized")) {
          $this
            .on("beforeChange", function (event, slick, currentSlide, nextSlide) {
              $(".scrollbar").stop().animate(
                {
                  scrollTop: 0,
                  suppressScrollX: true,
                },
                500
              );
            })
            .slick({
              infinite: false,
              swipe: false,
              prevArrow: $this.find(".nav-back"),
              nextArrow: $this.find(".nav-small"),
              speed: 250,
              responsive: [
                {
                  breakpoint: 768,
                  settings: {
                    adaptiveHeight: true,
                  },
                },
              ],
            });
        }
      });

      // if (Foundation.MediaQuery.atLeast('large')) {
      //   if (sl.hasClass('slick-initialized')) {
      //     sl.slick('unslick');
      //   }
      // } else {
      //   if (!sl.hasClass('slick-initialized')) {
      //     sl.slick(settings);
      //   }
      // }
    },
    setup_mobile_nav: function () {
      var api = $("#mobile-nav")
        .mmenu({
          extensions: ["effect-slide-menu"],
          offCanvas: {
            position: "right",
          },
          navbar: true,
          slidingSubmenus: false,
        })
        .data("mmenu");

      //   $window.resize(function () {
      //     api.close();
      //   });
    },
    setup_foundation: function () {
      console.log("loading foundation");
      $(document).foundation();
    },
    load_ajax_page: function (url, container, callback, stop_state) {
      if (window.history.pushState && !stop_state) {
        window.history.pushState(null, document.title, url);
      }

      $("<div></div>").load(url + " " + container, function (responseText, textStatus) {
        if (textStatus == "success" || textStatus == "error") {
          var html_content = $(this).children().html();

          $document.foundation("reflow");

          if (callback) {
            callback.call(this);
          }
        }
      });
    },
    show_fancybox: function (href, callback) {
      var show_it = function (href) {
        $.fancybox({
          type: "inline",
          href: href, //add_query_arg(href, 'ajax', 1),
          padding: 0,
          helpers: {
            overlay: {
              locked: false, // try changing to true and scrolling around the page
            },
          },
          afterShow: callback,
          scrolling: false,
          maxHeight: "100%",
          margin: Foundation.MediaQuery.current == "small" ? 10 : 20,
        });
      };

      if ($.isFunction($.fancybox)) {
        show_it(href);
      } else {
        $.getScript(wp_ajax.template_dir + "/js/lib/jquery.fancybox.pack.js", function () {
          show_it(href);
        });
      }
    },
    scroll_to_object: function (object, offset, speed) {
      if (!speed) {
        speed = "slow";
      }

      if (object.length) {
        $("body, html").animate(
          {
            scrollTop: object.offset().top - (offset ? offset : 95),
          },
          speed,
          function () {}
        );
      }
    },
    setup_bindings: function () {
      $window.on("viewport-units-buggyfill-style", function () {
        $window.trigger("resize");
      });

      $document
        .on("mouseenter", "#ss-container .cases-slider a", function () {
          var $this = $(this),
            index = $this.parents(".slide").data("index"),
            color = $this.parents(".slide").data("color"),
            sh = $("#success-hover-" + index),
            counter = sh.find(".counter");

          $(".background-image-slider").slick("slickGoTo", index);
          if (color) {
            $("#bg-gradient").css("background-color", color);
          }

          sh.addClass("visible");
          $("#success-hover-0").removeClass("visible");

          if (!sh.data("cnt")) {
            sh.data("cnt", counter.text().replace(/\./g, ""));
          }

          counter.prop("counter", 0).animate(
            {
              counter: sh.data("cnt"),
            },
            {
              duration: 2000,
              easing: "easeOutQuint",
              step: function (now) {
                $(this).text(addCommas(Math.ceil(now)));
              },
            }
          );
        })
        .on("mouseleave", "#ss-container:not(.transitioning) .cases-slider a", function () {
          var index = $(this).parents(".slide").data("index");

          $(".background-image-slider").slick("slickGoTo", 0);

          $("#bg-gradient").attr("style", "");

          $("#success-hover-0").addClass("visible");
          $("#success-hover-" + index)
            .removeClass("visible")
            .find(".counter")
            .stop();
        })
        .on("click", ".toggle-team-member-overlay", function (e) {
          e.preventDefault();

          $(this).parents(".team-member-block").toggleClass("opened");
        })
        .on("click", "#ss-container.transitioning a, #ss-container.transitioning button", function (e) {
          e.preventDefault();

          return false;
        })
        .on("click", ".submit-form-small", function (e) {
          e.preventDefault();

          $(this).prev().find(".wpforms-submit").trigger("click");
        })
        .on("mouseenter", ".floating-icon-link", function (e) {
          if (!Modernizr.touchevents) {
            $("#logo").addClass("invisible");
          }
        })
        .on("mouseleave", ".floating-icon-link", function (e) {
          if (!Modernizr.touchevents) {
            $("#logo").removeClass("invisible");
          }
        })
        .on("click", 'a[data-transition="to-home"]', function (e) {
          if (wp_ajax.original_homepage) {
            e.preventDefault();

            $(".background-image-slider").slick("slickGoTo", 0);
            $("#bg-gradient").attr("style", "");
            $("#success-hover-0").addClass("visible");

            var $container = $("#ss-container"),
              transition = Foundation.MediaQuery.current == "small" || Foundation.MediaQuery.current == "medium" ? "mobile" : "to-home";

            $container.addClass("transitioning transition-" + transition + " transition-" + transition + "-out");

            $html.removeClass("side-nav-open");

            setTimeout(
              function () {
                $("body").attr("class", "home original-home");
                $("#content").empty();
                $("body, html").scrollTop(0);
                document.title = wp_ajax.site_title;
                self.init_page_scripts();

                if (window.history.pushState) {
                  window.history.pushState(null, document.title, wp_ajax.hostname);
                }

                $container.removeClass("transition-" + transition + "-out").addClass("transition-" + transition + "-in");

                setTimeout(function () {
                  $container.removeClass("transitioning transition-" + transition + " transition-" + transition + "-in transition-" + transition + "-out");
                }, 1000);
              },
              Foundation.MediaQuery.atLeast("large") ? 500 : 1300
            );
          }
        })
        .on("click", ".interaction-play, .toggle-video", function (e) {
          e.preventDefault();

          var $this = $(this),
            ib = $this.parents(".video-block");

          if (!ib.hasClass("playing")) {
            ib.addClass("playing").removeClass("finished").find(".interaction-video").get(0).play();
          } else {
            ib.removeClass("playing").find(".interaction-video").get(0).pause();
          }
        })
        .on("click", ".cb-slider .slick-slide", function (e) {
          e.stopPropagation();

          var cbs = $(".cb-slider");

          var index = $(this).data("slick-index");
          if (cbs.slick("slickCurrentSlide") !== index) {
            cbs.slick("slickGoTo", index);
          }
        })
        .on("click", ".toggle-section", function (e) {
          e.preventDefault();

          var cs = $(this).toggleClass("opened").parents(".section-white").next(".collapsable");

          cs.slideToggle("slow", function () {
            self.scroll_to_object(cs, 0);
          });
        })
        .on("click", ".toggle-slidein", function (e) {
          e.preventDefault();

          if (Foundation.MediaQuery.current == "small") {
            var si = $(this).parents("#slide-in");
            if (si.hasClass("opened")) {
              si.css("margin-bottom", -55);
            }
          }

          $(this).next().stop().slideToggle().parents("#slide-in").toggleClass("opened");
        })
        .on("click", ".fancybox", function (e) {
          e.preventDefault();

          self.show_fancybox($(this).attr("href"), function () {
            // self.init_page_scripts();
          });
        })
        .on("click", ".toggle-side-nav", function (e) {
          e.preventDefault();

          $html.toggleClass("side-nav-open");

          if ($(this).hasClass("toggle-cases")) {
            $(".mobile-nav-slider").slick("slickGoTo", 1, true);
          }
        })
        .on("click", "#side-nav-overlay", function (e) {
          e.preventDefault();

          $html.removeClass("side-nav-open");
        })
        .on("click", ".toggle-fullscreen", function (e) {
          e.preventDefault();

          var elem = $(this).parent().children("video").get(0);

          if (elem.requestFullscreen) {
            elem.requestFullscreen();
          } else if (elem.mozRequestFullScreen) {
            elem.mozRequestFullScreen();
          } else if (elem.webkitRequestFullscreen) {
            elem.webkitRequestFullscreen();
          } else if (elem.msRequestFullscreen) {
            elem.msRequestFullscreen();
          }
        })
        .on("click", ".toggle-form-popup", function (e) {
          e.preventDefault();

          $(this).parents(".content-block .form-container").toggleClass("form-open");
          $body.toggleClass("form-popup-open");
        })
        .on("keyup", ".form-popup-open", function (e) {
          if (e.keyCode === 27) {
            $body.removeClass("form-popup-open");
            $(".form-open").removeClass("form-open");
          }
        })
        .on("click", ".quick-nav--with-card li a", function (e) {
          e.preventDefault();

          if ($(this).parents(".force-show").length > 0) {
            $(this).parents(".force-show").removeClass("force-show");
            return;
          }

          $(this).parents(".quick-nav").toggleClass("quick-nav--with-card--open");
        })
        .on("click", ".complex-table-block__button", function (e) {
          e.preventDefault();

          var $this = $(this);
          var $parent = $this.parents(".complex-table-block");
          var $prev = $parent.find(".complex-table-block__button--left");
          var $next = $parent.find(".complex-table-block__button--right");
          var current = $parent.data("active");
          var columns = $parent.data("columns");

          if ($this.hasClass("complex-table-block__button--left")) {
            if (current > 0) {
              var newIndex = current - 1;
              $parent.data("active", newIndex);
            }
          } else {
            if (current < columns) {
              var newIndex = current + 1;
              $parent.data("active", newIndex);
            }
          }
          var translate = newIndex * -100;
          $parent.find(".complex-table-block__not-first").css("transform", "translateX(" + translate + "%)");

          $next.attr("disabled", newIndex === columns);
          $prev.attr("disabled", newIndex === 0);
        });

      $(".open-directly").each(function () {
        window.scrollTo(0, $(this).offset().top - $window.height() / 2);
        $(this).parents(".content-block").addClass("form-open");
        $body.addClass("form-popup-open");
      });

      if (navigator.userAgent.match(/MSIE 10/i)) {
        $(".toggle-fullscreen").hide();
      }
    },
    setup_video_bindings: function () {
      $(".interaction-video").each(function () {
        this.onended = function () {
          var $this = $(this),
            ib = $this.parents(".video-block");
          ib.addClass("finished").removeClass("playing");
        };
      });
    },
    setup_mobile_complex_table: function () {
      var $parents = $(".complex-table-block");

      if ($parents.length < 1) {
        return;
      }

      $parents.each(function () {
        var $parent = $(this);
        var $table = $parent.children(".complex-table-block__table");
        var columns = $table.find("tr").first().children("td").length;

        $parent.data("columns", columns - 2);
        $parent.data("active", 0);

        if (!Foundation.MediaQuery.atLeast("medium")) {
          $table.width(columns * 50 + "%");
        }

        $(window).on(
          "resize",
          debounce(function () {
            if (Foundation.MediaQuery.atLeast("medium")) {
              $parent.data("active", 0);
              $parent.find(".complex-table-block__not-first").css("transform", "translateX(0)");
              $table.width("100%");
            } else {
              $table.width(columns * 50 + "%");
            }
          }, 300)
        );
      });
    },
  });

  $(document).ready(function () {
    new App();
  });
})(jQuery, window, document);
